import axios from "axios";
import { useState,useRef } from "react";
import SearchComponent from "./searchcomp";
import generatePDF, { Resolution, Margin } from 'react-to-pdf';
import { Link } from "react-router-dom";
import {HashLoader} from "react-spinners";
import logomain from "./esalab/ahk-removebg-preview.png";
import Failuremessage from "./failuremessage";
import pic3 from "./esalab/pic3.jpeg"

export default function RegisterPatient() {

  const [found,setFound] = useState([]);
  const [priceSelect,setPriceSelect] = useState([]);
  const [loading,setLoading] = useState(false);
  const targetref = useRef();
  const [resTwo, setResTwo] = useState();
  const [formData, setFormData] = useState({
    email: "",
    name: "",
    age:"",
    cnic:"",
    gender: "male",
    dob:"",
    mobileNumber: "",
    searchResult:"",
    priceofsearch:"",
    discount:"",
    received:"",
    labnumber:"",
    reference:""
  });
  const formFields = [
    { label: 'Name', value: formData.name },
    { label: 'Age', value: formData.age },
    { label: 'Email', value: formData.email },
    { label: 'Mobile Number', value: formData.mobileNumber },
    { label: 'CNIC', value: formData.cnic },
    { label: 'Date Of Birth', value: formData.dob },
    { label: 'Gender', value: formData.gender },
    {label:"Reference",value:formData.reference},
    {label:"Lab Number",value:formData.labnumber}
  ];
   const rootUrl = "http://localhost:3000";
  const localrootUrl = "https://ahkserver.onrender.com";

  const handleSearchSelect = (selectedTest) => {
    
    if(selectedTest.item){
      setFormData({ ...formData, searchResult: selectedTest.item.key,priceofsearch:selectedTest.item.price });
    }
    
  };


  function calSum(data){
    var sum = 0;
    for(var i=0;i<data.length;i++){
      sum += data[i];
    }
    return sum;
  }

  const options = {
    // default is `save`
    method: 'open',
    // default is Resolution.MEDIUM = 3, which should be enough, higher values
    // increases the image quality but also the size of the PDF, so be careful
    // using values higher than 10 when having multiple pages generated, it
    // might cause the page to crash or hang.
    resolution: Resolution.MEDIUM,
    page: {
       // margin is in MM, default is Margin.NONE = 0
       margin: Margin.SMALL,
       // default is 'A4'
       format: 'letter',
       // default is 'portrait'
       orientation: 'landscape',
    },
    canvas: {
       // default is 'image/jpeg' for better size performance
       mimeType: 'image/png',
       qualityRatio: 1
    },
    // Customize any value passed to the jsPDF instance and html2canvas
    // function. You probably will not need this and things can break, 
    // so use with caution.
    overrides: {
       // see https://artskydj.github.io/jsPDF/docs/jsPDF.html for more options
       pdf: {
          compress: true
       },
       // see https://html2canvas.hertzen.com/configuration for more options
       canvas: {
          useCORS: true
       }
    },
 };

 function formTwoSubmit(event){
  setLoading(true);
  event.preventDefault();
  const fetchData = async ()=>{
    var priceobj = [];
    var testobj = [];
    for(var i =0;i<priceSelect.length;i++){
      priceobj.push({price:priceSelect[i]});
      testobj.push({name:found[i]});
    }
      try{
        console.log(priceobj,testobj);
          const dataposter = await axios.post(`${localrootUrl}/logUser`,{...formData,tests:testobj,testPrices:priceobj},{withCredentials:true});
      const response = dataposter.data;
      if(response.failure || response.success){
        setLoading(false);
      }
      setResTwo(response);
      }catch(error){
          console.log(error);
          setLoading(true);
      }
  }
  fetchData();
  // setFormData({
  //   email: "",
  //   name: "",
  //   age:"",
  //   cnic:"",
  //   gender: "",
  //   dob:"",
  //   mobileNumber: "",
  //   searchResult:"",
  //   priceofsearch:"",
  //   discount:""
  // });
  setFound([]);
  setPriceSelect([]);
}

// useEffect(()=>{
//   const fetchMrnumber = async ()=>{
//     try{
//       const getmr = await axios(`${rootUrl}/getSinglemrnumber`,{email:formData.email,mobileNumber:formData.mobileNumber,name:formData.name});
//       const mr = getmr.data;
//       if(mr.mrnumber){
//         setmrno(mr.mrnumber);
//       }
//     }catch(err){
//       console.log(err.message);
//     }
//    }
//    fetchMrnumber();
// },[])
function checkEmail(){
  if(formData.email.includes("@") && formData.email.includes(".com") && formData.email.length>5){
    return {"success":"Valid"};
  }else{
    return {"failure":"*Invalid Email"};
  }
}

 
 const getTargetElement = () => document.getElementById('content-id');

  // if(loading){
  //   return (
  //     <div className="spinner-container">
  //       <ClipLoader size={150} className="loader" loading={loading} />
  //     </div>
  //   );
  // }else {
    return (
    <div className="register">
      <form onSubmit={formTwoSubmit} method="POST" className="former" style={{padding:"0vw"}}>
        <h2 className="updates">
        {loading?<HashLoader size={50} className="newloader" loading={loading}/>:resTwo?resTwo.failure?<Failuremessage custommessage={resTwo.failure} isFail={true}/>:<Failuremessage successmessage={resTwo.success} isFail={false}/>:<p className="updates">Enter Patient Info</p>}
        </h2>
        <div className="subform">
        <div className="form-col">
          <input
            className="inputtext"
            type="text"
            name="email"
            required
            placeholder="Enter Email"
            value={formData.email}
            onChange={(event) => setFormData({ ...formData, email: event.target.value })}
            />
          <label className="label-contact" style={{color:"red"}}>{checkEmail().failure?checkEmail().failure:null}</label>
        </div>
        <div className="form-col">
          <input
            className="inputtext"
            type="text"
            name="name"
            required
            placeholder="Enter Name"
            value={formData.name}
            onChange={(event) => setFormData({ ...formData, name: event.target.value })}
          />
          <label className="label-contact" style={{color:"red"}}>{formData.name.length>=3?null:"Name must be at least 3 letters"}</label>
        </div>
        <div className="form-col">
          <input
            className="inputtext"
            type="number"
            required
            name="mobileNumber"
            placeholder="Enter Mobile Number"
            value={formData.mobileNumber}
            onChange={(event) => setFormData({ ...formData, mobileNumber: event.target.value })}
          />
          <label className="label-contact" style={{color:"red"}}>{formData.mobileNumber.length==11?null:"Invalid Phone Number"}</label>
        </div>
        <div>
          <input
          className="inputtext"
          type="number"
          style={{width:"10vw"}}
          max={100}
          min={0}
          name="discount"
          placeholder="Enter Dicount"
          value={formData.discount}
          onChange={(event) => setFormData({ ...formData, discount: event.target.value })}
          />
        </div>
        <input
        className="inputtext"
        type="text"
        name="reference"
        placeholder="Enter Reference"
        value={formData.reference}
        onChange={(event) => setFormData({ ...formData, reference: event.target.value })}
        />
        <input
        className="inputtext"
        style={{width:"10vw"}}
        type="number"
        name="age"
        required
        max={120}
        min={1}
        placeholder="Enter Age"
        value={formData.age}
        onChange={(event) => setFormData({ ...formData, age: event.target.value })}
        />
        <div className="form-col">
          <input
            className="inputtext"
            type="number"
            required
            name="cnic"
            placeholder="Enter CNIC"
            value={formData.cnic}
            onChange={(event) =>setFormData({ ...formData, cnic: event.target.value })}
          />
          <label className="label-contact" style={{color:"red"}}>{formData.cnic.length==13?null:"Invalid CNIC"}</label>
        </div>
        <select className="inputtext" id="cars" value={formData.gender} name="gender" onChange={(event)=>{setFormData({...formData,gender:event.target.value})}}>
          <option value="male">Male</option>
          <option value="female">Female</option>
        </select>
        <input
          className="inputtext"
          type="date"
          required
          name="dob"
          placeholder="Enter Date of Birth"
          value={formData.dob}
          onChange={(event) => setFormData({ ...formData, dob: event.target.value })}
        />
        <input
          className="inputtext"
          type="number"
          required
          name="labnumber"
          placeholder="Enter Lab Number"
          value={formData.labnumber}
          onChange={(event) => setFormData({ ...formData, labnumber: event.target.value })}
        />
        </div>
        <button className="submit" disabled={checkEmail().success && formData.mobileNumber.length==11 && formData.name.length>=3 && formData.cnic.length==13?false:true} style={checkEmail().success && formData.mobileNumber.length==11 && formData.name.length>=3 && formData.cnic.length==13?null:{opacity:0.5,cursor:"not-allowed"}} type="submit">Submit</button>
        <Link to="/seeAll" className="updates link" style={{ color: "black", cursor: "pointer" }}>See All Data</Link>
      </form>
      <div className="invoice-gen">

         <button className="generatepdf" onClick={() =>{ 

         generatePDF(getTargetElement, options);
         }
         
         }>Generate PDF</button>
         <div id="content-id" ref={targetref}>
            <div className="pdfHead">
                <p className="pdfHead-txt">MR Number: {resTwo?resTwo.mrnumber?resTwo.mrnumber:null:null}</p>
                <img alt="logo" className="logo" src={logomain}/>
                <p className="pdfHead-txt">Date: {new Date().getDate()+"/ "+new Date().getMonth()+"/ "+new Date().getFullYear()}</p>
            </div>
            <div className="pdf-data">
              <div className="pdfsub">
                  {formFields.map((field, index) => {
                    if(index<=4){
                      return <div className="fielddata">
                      <p className="labels">{field.label}:</p>
                      <p className="pdfdata-txt">{field.value}</p>
                    </div>
                    }else{
                      return null
                    }
                })}
              </div>
              <div className="pdfsub">
                  {formFields.map((field, index) => {
                    if(index>4){
                      return <div className="fielddata">
                    <p className="labels">{field.label}:</p>
                    <p className="pdfdata-txt">{field.value}</p>
                  </div>
                    }else{
                      return null
                    }
                })}
              </div>
          </div>

          <div className="balancesheet">
            <div className="discount-div">
              <h2><strong>Examination:</strong></h2>
            </div>
            <div ref={targetref} className="billsheet-div">
            {
              found.map((oneFound,index)=>{
                return <form className="billsheet">
                  <p className="discount">{index+1+". "}{oneFound}</p>
                  {/* <p>{formData.discount}</p> */}
                  <p className="discount">RS {priceSelect[index]}</p>
                </form>
              })
            }  
            </div>
            <div className="paisa">
              <div className="balancetxt-div">
                <h3 className="balance-txt">Discount: </h3>
                <h3 className="balance-txt">{formData.discount?formData.discount:0}%</h3>
              </div>
              <div className="balancetxt-div">
                <h3 className="balance-txt">Total:</h3>
                <h3 className="balance-txt">Rs {calSum(priceSelect)*((100-formData.discount)/100)}</h3>
              </div>
              <div className="balancetxt-div">
                <h3 className="balance-txt">Received:</h3>
                <h3 className="balance-txt"> Rs {formData.received?formData.received:0}</h3>
              </div>
              <div className="balancetxt-div">
                <h3 className="balance-txt">Balance:</h3>
                <h3 className="balance-txt"> Rs {calSum(priceSelect)*((100-formData.discount)/100)-formData.received}</h3>
              </div>
            </div>
            <img alt="logo" src={pic3} style={{margin:0}} className="logo"/>
          </div>
         </div>
         <input
              className="inputtext"
              type="number"
              style={{width:"17vw"}}
              name="received"
              placeholder="Enter Amount Received"
              value={formData.received}
              onChange={(event) => setFormData({ ...formData, received: event.target.value })}
            />
         <div className="selectordata">
         <label className="labels">Search For scans:</label>
         <SearchComponent onSelectRecord={handleSearchSelect} />
         <button className="submit" onClick={()=>{setFound((prevVal)=>{return [...prevVal,formData.searchResult]}); setPriceSelect((prevVal)=>{return [...prevVal,formData.priceofsearch]})}}>Add To Invoice</button>
         </div>
         <button className="submit" style={{marginTop:"2vw"}} onClick={()=>setFound((prevVal)=>{return []})}>Delete All</button>
      </div>
    </div>
  );
}